import { useEffect, useState } from 'react';
import { api } from '../api.js';
import { useAuth } from '../context/AuthContext.jsx';
import {
  isPushSupported,
  ensureSubscription,
  unsubscribe,
  currentPermission,
  isStandalone,
} from '../push.js';

export default function SettingsPage() {
  const { user } = useAuth();
  const [permission, setPermission] = useState(currentPermission());
  const [subscribed, setSubscribed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    (async () => {
      if (!('serviceWorker' in navigator)) return;
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.getSubscription();
      setSubscribed(!!sub);
    })();
  }, []);

  async function enablePush() {
    setMsg(null);
    setBusy(true);
    try {
      const sub = await ensureSubscription();
      if (!sub) {
        setMsg('Permesso negato o non supportato.');
      } else {
        setSubscribed(true);
        setPermission('granted');
        setMsg('Notifiche attivate.');
      }
    } catch (ex) {
      setMsg(ex.message);
    } finally {
      setBusy(false);
    }
  }

  async function disablePush() {
    setBusy(true);
    setMsg(null);
    try {
      await unsubscribe();
      setSubscribed(false);
      setMsg('Notifiche disattivate.');
    } catch (ex) {
      setMsg(ex.message);
    } finally {
      setBusy(false);
    }
  }

  async function testPush() {
    setBusy(true);
    setMsg(null);
    try {
      const r = await api.post('/push/test');
      setMsg(`Test inviato (${r.sent || 0} dispositivi).`);
    } catch (ex) {
      setMsg(ex.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <div className="card">
        <h2>Account</h2>
        <p>
          <strong>{user?.name}</strong>
          <br />
          <span className="muted">{user?.email}</span>
        </p>
      </div>

      <div className="card">
        <h2>Notifiche push</h2>
        {!isPushSupported() && (
          <p className="muted">Il tuo browser non supporta le notifiche push.</p>
        )}
        {isPushSupported() && (
          <>
            <p className="muted">
              Permesso: <strong>{permission}</strong>
              <br />
              Sottoscrizione: <strong>{subscribed ? 'attiva' : 'disattivata'}</strong>
            </p>
            {!isStandalone() && /iPhone|iPad|iPod/.test(navigator.userAgent) && (
              <p className="muted">
                Su iOS le notifiche push funzionano solo dopo aver installato la PWA dalla
                schermata Home di Safari (Condividi &rarr; Aggiungi a Home).
              </p>
            )}
            <div className="row">
              {!subscribed ? (
                <button onClick={enablePush} disabled={busy}>Attiva notifiche</button>
              ) : (
                <>
                  <button className="secondary" onClick={testPush} disabled={busy}>
                    Test
                  </button>
                  <button className="danger" onClick={disablePush} disabled={busy}>
                    Disattiva
                  </button>
                </>
              )}
            </div>
            {msg && <p className="muted" style={{ marginTop: '0.5rem' }}>{msg}</p>}
          </>
        )}
      </div>
    </div>
  );
}
